module.exports = __webpack_public_path__ + "img/util-today.8d9b6bb.png";